import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import CreateDevice from '../../components/device/CreateDevice'
import Footer from '../../components/common/Footer'

export default function CreateDevicePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <CreateDevice />
            <Footer/>
        </>
    )
}
